module.exports = __webpack_public_path__ + "1_0_57/img/pass_show.c760790b.svg";